import React, { Component } from 'react'
import Sprite from '~components/Sprite'

class Legend extends Component {
  render () {
    return (
      <div className="w-auto px-2 my-2 lg:px-3">
        <div className="-mx-2 -my-1 flex flex-wrap items-center">
          <div className="px-2 my-1 flex items-center">
            <span className="w-4 h-3 rounded-sm block bg-light-green mr-2" aria-hidden="true"></span>
            Available to order
          </div>

          <div className="px-2 my-1 flex items-center">
            <span className="w-4 h-3 rounded-sm block bg-light-yellow mr-2" aria-hidden="true"></span>
            Low stock
          </div>

          <div className="px-2 my-1 flex items-center">
            <span className="w-4 h-3 rounded-sm block bg-light-red mr-2" aria-hidden="true"></span>
            Available for back order/future delivery
          </div>

          <div className="px-2 my-1 flex items-center">
            <span className="w-4 h-3 block mr-2" aria-hidden="true">
              <Sprite name="discontinued" />
            </span>
            Unavailable
          </div>

          <div className="px-2 my-1 flex items-center">
            <span className="w-4 h-4 block mr-2" aria-hidden="true">
              <Sprite name="questionMark" />
            </span>

            <a href="mailto:info@panache-lingerie.com" className="underline hover:no-underline">
              Need help ordering?
            </a>
          </div>
        </div>
      </div>
    )
  }
}

export default Legend
